

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Badge, Button, Card, Grid, ODataTable, QueryOptions, Tabs, Toolbar, ButtonGroup,
} from 'framework-ui-components';
import { SnackbarWrapper as SnackbarManager } from 'framework-ui-components/Components/Snackbar';

import { PageWrapper } from 'dashboard';
import throttle from '../../helpers/throttle';
import EventoServer from '../../libs/EventoServer';
import RigaOperazione from './RigaOperazione';
import { contatori } from '../../apis/elaborazioniMassiveApi';

class OperazioniMassive extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
      dichiarazioni: [],
      stati: {},
    };

    this.initializeComponent();
  }

  componentWillMount() {
    this.caricaContatori(this.props.ufficioSelezionato.CodiceUfficio);
  }

  componentDidMount() {
    EventoServer.subscribe('ElaborazioneMassivaAvviata', this.ricarica);
    EventoServer.subscribe('ElaborazioneMassivaAvanzata', this.ricarica);
    EventoServer.subscribe('ElaborazioneMassivaCompletata', this.ricarica);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.ufficioSelezionato.CodiceUfficio != nextProps.ufficioSelezionato.CodiceUfficio) {
      this.caricaContatori(nextProps.ufficioSelezionato.CodiceUfficio);
    }
  }

  componentWillUnmount() {
    EventoServer.unsubscribe('ElaborazioneMassivaAvviata', this.ricarica);
    EventoServer.unsubscribe('ElaborazioneMassivaAvanzata', this.ricarica);
    EventoServer.unsubscribe('ElaborazioneMassivaCompletata', this.ricarica);
  }

  initializeComponent() {
    this.caricaContatori = this.caricaContatori.bind(this);
    this.ricarica = throttle(this.ricarica.bind(this), 5000);
  }

  caricaContatori(studio) {
    contatori(studio)
      .then((x) => {
        this.setState({ stati: x });
      });
  }

  ricarica() {
    this.caricaContatori(this.props.ufficioSelezionato.CodiceUfficio);
    this.tabellaDichiarazioni.loadPage();
  }

  render() {
    const { ufficioSelezionato } = this.props;
    const { stati } = this.state;

    const badgeConteggio = count => (count != 0 ? <Badge info>{count}</Badge> : null);

    return (
      <PageWrapper helmetTitle="Monitoraggio elaborazioni" pageTitle="Monitoraggio elaborazioni" pageBack>
        <Grid fluid className="pl-0 pr-0">
          <Grid.Row>
            <Grid.Col md="12">
              <Card title="Elenco operazioni" className="table--filters-15">
                <Tabs initialIndex={0}>
                  <Tabs.Tab title={<span>Tutte {badgeConteggio(stati.Totale)}</span>}>
                    <ODataTable
                      ref={r => this.tabellaDichiarazioni = r}
                      hover
                      clickable
                      url={`/ElaborazioniMassive/Tutte?codiceUfficio=${ufficioSelezionato.CodiceUfficio}`}
                      row={RigaOperazione}
                      pageSize={10}
                      availablePageSizes={[10, 20, 50]}
                    >
                      <ODataTable.Column propertyName="Id">Seriale</ODataTable.Column>
                      <ODataTable.Column propertyName="Servizio">Servizio</ODataTable.Column>
                      <ODataTable.Column propertyName="Operazione">Operazione</ODataTable.Column>
                      <ODataTable.Column propertyName="Stato">Stato</ODataTable.Column>
                      <ODataTable.Column>Elementi elaborati</ODataTable.Column>
                      <ODataTable.Column>Inizio elaborazione</ODataTable.Column>
                      <ODataTable.Column>Fine elaborazione</ODataTable.Column>
                    </ODataTable>
                  </Tabs.Tab>

                  <Tabs.Tab title={<span>In corso {badgeConteggio(stati.InCorso)}</span>}>
                    <ODataTable
                      ref={r => this.tabellaDichiarazioni = r}
                      hover
                      clickable
                      url={`/ElaborazioniMassive/InCorso?codiceUfficio=${ufficioSelezionato.CodiceUfficio}`}
                      row={RigaOperazione}
                      pageSize={10}
                      availablePageSizes={[10, 20, 50]}
                    >
                      <ODataTable.Column propertyName="Id">Seriale</ODataTable.Column>
                      <ODataTable.Column propertyName="Servizio">Servizio</ODataTable.Column>
                      <ODataTable.Column propertyName="Operazione">Operazione</ODataTable.Column>
                      <ODataTable.Column propertyName="Stato">Stato</ODataTable.Column>
                      <ODataTable.Column>Elementi elaborati</ODataTable.Column>
                      <ODataTable.Column>Inizio elaborazione</ODataTable.Column>
                      <ODataTable.Column>Fine elaborazione</ODataTable.Column>
                    </ODataTable>
                  </Tabs.Tab>

                  <Tabs.Tab title={<span>Terminate {badgeConteggio(stati.Terminate)}</span>}>
                    <ODataTable
                      ref={r => this.tabellaDichiarazioni = r}
                      hover
                      clickable
                      url={`/ElaborazioniMassive/Terminate?codiceUfficio=${ufficioSelezionato.CodiceUfficio}`}
                      row={RigaOperazione}
                      pageSize={10}
                      availablePageSizes={[10, 20, 50]}
                    >
                      <ODataTable.Column propertyName="Id">Seriale</ODataTable.Column>
                      <ODataTable.Column propertyName="Servizio">Servizio</ODataTable.Column>
                      <ODataTable.Column propertyName="Operazione">Operazione</ODataTable.Column>
                      <ODataTable.Column propertyName="Stato">Stato</ODataTable.Column>
                      <ODataTable.Column>Elementi elaborati</ODataTable.Column>
                      <ODataTable.Column>Inizio elaborazione</ODataTable.Column>
                      <ODataTable.Column>Fine elaborazione</ODataTable.Column>
                    </ODataTable>
                  </Tabs.Tab>
                </Tabs>
              </Card>
            </Grid.Col>
          </Grid.Row>
        </Grid>
      </PageWrapper>
    );
  }
}

const mapStoreToProps = store => ({
  ufficioSelezionato: store.utente.ufficioSelezionato,
});

OperazioniMassive.propTypes = {
  ufficioSelezionato: PropTypes.object,
};

export default connect(mapStoreToProps)(OperazioniMassive);
